<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Knowledge, Power,<br/> Wealth and Wisdom</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#preface">Preface</a></li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-1-world-of-wonder">Chapter 1: World of Wonder</a></li>
<li id="toc-li-7"><a href="#/text/ch007#chapter-2-narration-of-knowledge">Chapter 2: Narration of Knowledge</a></li>
<li id="toc-li-8"><span href="#/text/ch008#chapter-3-logic-and-language" title="Link target outside of Sample">Chapter 3: Logic and Language</span></li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-4-god-and-godlessness" title="Link target outside of Sample">Chapter 4: God and Godlessness</span></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-5-ethics-and-egoism" title="Link target outside of Sample">Chapter 5: Ethics and Egoism</span></li>
<li id="toc-li-11"><span href="#/text/ch011#chapter-6-state-and-society" title="Link target outside of Sample">Chapter 6: State and Society</span></li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-7-economics-and-extravagance" title="Link target outside of Sample">Chapter 7: Economics and Extravagance</span></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-8-education-and-etiquette" title="Link target outside of Sample">Chapter 8: Education and Etiquette</span></li>
<li id="toc-li-14"><span href="#/text/ch014#chapter-9-homes-and-health" title="Link target outside of Sample">Chapter 9: Homes and Health</span></li>
<li id="toc-li-15"><span href="#/text/ch015#chapter-10-environment-and-energy" title="Link target outside of Sample">Chapter 10: Environment and Energy</span></li>
<li id="toc-li-16"><span href="#/text/ch016#chapter-11-philos-sophia" title="Link target outside of Sample">Chapter 11: Philos Sophia</span></li>
<li id="toc-li-17"><span href="#/text/ch017#bibliography" title="Link target outside of Sample">Bibliography</span></li>
<li id="toc-li-18"><span href="#/text/ch018#abbreviations" title="Link target outside of Sample">Abbreviations</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?05c6ca75